import {
  Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, EventEmitter
} from '@angular/core';

import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { HotelReservation } from '@booking/entities/hotel-validation.response';
import { formatStrinWithTimeZoneDateByRegex } from '@ux/mappers/date.mapper';
import { totalNights } from '@ux/mappers/guest.mapper';
import { GenericCardSpaces } from '@design-system/components/templates/generic-card/entities/generic-card.types';

@Component({
  selector: 'app-hotel-small-reservation',
  templateUrl: './hotel-small-reservation.component.html',
  styleUrls: ['./hotel-small-reservation.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HotelSmallReservationComponent {

  @Input() hotelReservation: HotelReservation;
  @Input() referenceCode: string;

  @Output() showMoreInfo: EventEmitter<void> = new EventEmitter<void>();

  public readonly fontFamily = TypographyFontFamily;
  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
    
  public readonly genericCardSpaces = GenericCardSpaces;

  constructor() { }

  get checkin(): string {
    return this.hotelReservation?.Checkin;
  }

  get checkout(): string {
    return this.hotelReservation?.Checkout;
  }

  get checkinDate(): Date {
    return new Date(formatStrinWithTimeZoneDateByRegex(this.checkin));
  }

  get checkoutDate(): Date {
    return new Date(formatStrinWithTimeZoneDateByRegex(this.checkout));
  }

  get nights(): number {
    return this.hotelReservation ? totalNights(this.checkout, this.checkin) : 0;
  }

  get isOneNight(): boolean {
    return !!this.nights && this.nights === 1;
  }

}
